import React, { useState } from 'react';
import { Row, Col, Input, Button, Alert } from 'reactstrap';

export interface Trabajador {
  matricula: string;
  esDirector: boolean;
}

const Trabajadores = (props: any) => {
  const {
    data,
    setData,
    disabled,
  } = props;

  const [error, setError] = useState<string>('');

  const handleTrabajadorChange = (index: number, field: keyof Trabajador, val: string | boolean) => {
    const nuevosTrabajadores = [...data.trabajadores];

    if (field === 'matricula') {
      nuevosTrabajadores[index].matricula = val as string;
    }
    if (field === 'esDirector') {
      nuevosTrabajadores[index].esDirector = val as boolean;
    }

    setData({
      ...data,
      trabajadores: nuevosTrabajadores,
    });
    setError('');
  };

  const agregarTrabajador = () => {
    setData({
      ...data,
      trabajadores: [...data.trabajadores, { matricula: '', esDirector: false }],
    });
  };

  const eliminarTrabajador = (index: number) => {
    const nuevosTrabajadores = data.trabajadores.filter((_: any, i: number) => i !== index);
    setData({
      ...data,
      trabajadores: nuevosTrabajadores,
    });
  };

  return (
    <div>
      {error && (
        <Alert color='danger' className='py-1 mb-3'>
          {error}
        </Alert>
      )}

      {data.trabajadores.map((trabajador: Trabajador, index: number) => (
        <Row key={index} className='align-items-center mb-2'>
          <Col sm={4}>
            <Input
              type='number'
              className="form-control"
              value={trabajador.matricula ?? ''}
              onChange={e => handleTrabajadorChange(index, 'matricula', e.target.value)}
              disabled={disabled}
              placeholder='Matrícula'
              required
            />
          </Col>

          <Col sm={3}>
            <Input
              type='checkbox'
              checked={!!trabajador.esDirector}
              onChange={e => handleTrabajadorChange(index, 'esDirector', e.target.checked)}
              disabled={disabled}
              style={{
                position: 'revert',
                marginRight: '5px',
              }}
              required
            />
            <label className='form-control-label'>Es codirector</label>
          </Col>

          <Col sm={2} className='text-center'>
            <Button
              color='danger'
              type='button'
              onClick={() => eliminarTrabajador(index)}
              size='sm'
              disabled={disabled}
            >
              ✕
            </Button>
          </Col>
        </Row>
      ))}

      <Button
        color='secondary'
        type='button'
        className='mt-2'
        onClick={agregarTrabajador}
        disabled={disabled}
      >
        + Agregar trabajador
      </Button>
    </div>
  );
};

export default Trabajadores;
